module.exports = __webpack_public_path__ + "static/media/22_before.3b132b1f.jpg";